<template>
  <div>
    <NoticeSearch :queryParams="queryParams" :fullDate="fullDate"/>
    <NoticeList :queryParams="queryParams" :fullDate="fullDate" :fieldItems="fieldItems"/>
  </div>
</template>
<script>


import DatePicker from 'vue2-datepicker';

const moment = require("moment");
import cSwitch from '../../components/Switch'
import NoticeSearch from "./component/NoticeSearch";
import NoticeList from "./component/NoticeList";
export default {
  name:'NoticeManagement',
  components: {
    NoticeList,
    NoticeSearch,
    DatePicker,
    cSwitch
  },
  data() {
    return {
      fullDate: [],
      queryParams: {
        start_date: '',
        end_date: '',
        keyword: '',
      },
      fieldItems: [{
        'rnum': {
          'label': '번호',
          'class': 'text-center',
          'thStyle': {
            'vertical-align': 'middle'
          }
        }
      }, {
        'top_yn': {
          'label': '상단공지',
          'class': 'text-center',
          'thStyle': {'vertical-align': 'middle'}
        }
      }, {
        'subject': {
          'label': '제목',
          'class': 'text-center',
          'thStyle': {
            'vertical-align': 'middle',
            'text-align': 'center'
          }
        }
      }, {
        'reg_name': {
          'label': '등록일',
          'class': 'text-center',
          'thStyle': {
            'vertical-align': 'middle'
          }
        }
      }, {
        'reg_date': {
          'label': '등록자',
          'class': 'text-center',
          'thStyle': {
            'vertical-align': 'middle'
          }
        }
      }],
    }
  },
  computed: {
    listRows() {
      return this.items.length
    }
  },
  mounted: function() {
  },
  methods: {
    getFormatDate(date) {
      if (!date) return;
      return moment(date).format("YYYY-MM-DD");
    },
  }
}

</script>




// WEBPACK FOOTER //
// src/views/notice/NoticeManagement.vue